var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFFFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5025 7.00024H7.50033C6.67172 7.00024 6 7.67196 6 8.50057V17.5025C6 18.3311 6.67172 19.0029 7.50033 19.0029H17.5025C18.3311 19.0029 19.0028 18.3311 19.0028 17.5025V8.50057C19.0028 7.67196 18.3311 7.00024 17.5025 7.00024Z",
    stroke: "black",
    strokeWidth: 1.00189,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7557 12.5088C14.172 12.5088 14.5095 12.1713 14.5095 11.755C14.5095 11.3387 14.172 11.0012 13.7557 11.0012C13.3394 11.0012 13.002 11.3387 13.002 11.755C13.002 12.1713 13.3394 12.5088 13.7557 12.5088Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2552 12.5088C16.6715 12.5088 17.009 12.1713 17.009 11.755C17.009 11.3387 16.6715 11.0012 16.2552 11.0012C15.8389 11.0012 15.5015 11.3387 15.5015 11.755C15.5015 12.1713 15.8389 12.5088 16.2552 12.5088Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7557 15.0093C14.172 15.0093 14.5095 14.6718 14.5095 14.2555C14.5095 13.8392 14.172 13.5017 13.7557 13.5017C13.3394 13.5017 13.002 13.8392 13.002 14.2555C13.002 14.6718 13.3394 15.0093 13.7557 15.0093Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2552 15.0093C16.6715 15.0093 17.009 14.6718 17.009 14.2555C17.009 13.8392 16.6715 13.5017 16.2552 13.5017C15.8389 13.5017 15.5015 13.8392 15.5015 14.2555C15.5015 14.6718 15.8389 15.0093 16.2552 15.0093Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75463 15.0093C9.17093 15.0093 9.50841 14.6718 9.50841 14.2555C9.50841 13.8392 9.17093 13.5017 8.75463 13.5017C8.33833 13.5017 8.00085 13.8392 8.00085 14.2555C8.00085 14.6718 8.33833 15.0093 8.75463 15.0093Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2543 15.0093C11.6706 15.0093 12.0081 14.6718 12.0081 14.2555C12.0081 13.8392 11.6706 13.5017 11.2543 13.5017C10.838 13.5017 10.5005 13.8392 10.5005 14.2555C10.5005 14.6718 10.838 15.0093 11.2543 15.0093Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75463 17.51C9.17093 17.51 9.50841 17.1725 9.50841 16.7562C9.50841 16.3399 9.17093 16.0024 8.75463 16.0024C8.33833 16.0024 8.00085 16.3399 8.00085 16.7562C8.00085 17.1725 8.33833 17.51 8.75463 17.51Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2543 17.51C11.6706 17.51 12.0081 17.1725 12.0081 16.7562C12.0081 16.3399 11.6706 16.0024 11.2543 16.0024C10.838 16.0024 10.5005 16.3399 10.5005 16.7562C10.5005 17.1725 10.838 17.51 11.2543 17.51Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7557 17.51C14.172 17.51 14.5095 17.1725 14.5095 16.7562C14.5095 16.3399 14.172 16.0024 13.7557 16.0024C13.3394 16.0024 13.002 16.3399 13.002 16.7562C13.002 17.1725 13.3394 17.51 13.7557 17.51Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50043 6V7.00922",
    stroke: "black",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5026 6V7.00922",
    stroke: "black",
    strokeWidth: 1.00189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0028 9.50098H6",
    stroke: "black",
    strokeWidth: 1.00189,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCalendar);
export default __webpack_public_path__ + "static/media/btnCalendar.a02007738c2db2e3d24d0a2514a039d6.svg";
export { ForwardRef as ReactComponent };